import { HiwItems } from "./types";

export const stepItems: HiwItems = [
  {
    question: "How do you decide the future buy-back price?",
    answer:
      "The Future Buy-Back Price is agreed in advance and will reflect the current market value with an estimated increase included.",
  },
  {
    question: "What if I can’t get a mortgage?",
    answer:
      "If you can't get a mortgage you are free to leave with no penalties. We could also look at extending your future buyback agreement so you can continue to get mortgage ready.",
  },
];
